import { IFormField} from "../web-form.objects"
import { JsonItem, PickListItem } from "../../../entities/pick-list/pick-list.entities";
import _ from "lodash";

export class MultiAddInputOptions {
    noItemDisplay: string; // What is shown when nothing is added
    isPickList: boolean = false; // if the add content should be pulled from pick list
    optionsId: string;
    options: PickListItem[] = undefined;
    sortOptions: boolean = true;
    constructor(noItemDisplay: string, isPickList: boolean = false, optionsId: string, sortOptions: boolean = true) {
        this.noItemDisplay = noItemDisplay;
        this.isPickList = isPickList;
        this.options = undefined;
        this.optionsId = optionsId;
        this.sortOptions = sortOptions;
    }
}

export class MultiAddInputField implements IFormField {
    fieldId: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    initialVal: any;

    options: MultiAddInputOptions;

    storedValues: string[];
    addedItemGallery: JQuery<HTMLElement>;
    addItemInput: JQuery<HTMLElement>;
    addItemBtn: JQuery<HTMLElement>;
    errorTextBlock: JQuery<HTMLElement>;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: MultiAddInputOptions) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.options = options;

        this.defaultVal = "";
        this.initialVal = "";

        this.storedValues = [];
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let input = `<input type="text" class="form-control" id="multi-add-input" placeholder="${this.displayName}...">`;
        if (this.options.isPickList) {
            input = `<select class="form-control" id="multi-add-input"></select>`;
        }

        let html = `
            <label class="label-title ${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            <div id="${this.fieldId}" class="multi-add">
                <div class="added-content">

                </div>
                <hr />
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <button class="btn multi-add-btn" type="button">Add +</button>
                    </div>
                    ${input}
                </div>
                <p class="error-msg d-none">Please add at least 1 item.</p>
            </div>
        `;

        return html;
    }

    initialize() {
        let formBlock = $(`#${this.fieldId}`);
        this.addedItemGallery = formBlock.find(".added-content");
        this.addItemInput = formBlock.find("#multi-add-input");
        this.addItemBtn = formBlock.find(".multi-add-btn");
        this.errorTextBlock = formBlock.find(".error-msg");

        if (this.options.isPickList) {
            this.generateDropdown();
        };

        this.initializeAddBtn();
        this.drawGallery();
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;
        let sharedValues: string[] = [];

        let testCases: string[] = [];
        items.forEach(item => {
            let val = <string>_.get(item, this.propertyName);
            let valArr = val.split("|");
            testCases.push(...valArr);
        })
        testCases = _.uniq(testCases);

        testCases.forEach(x => {
            let allShare = items.every(item => {
                let val = <string>_.get(item, this.propertyName);
                let valArr = val.split("|");
                return valArr.includes(x);
            });

            if (allShare) {
                sharedValues.push(x);
            }
        });
        this.initialVal = sharedValues.join("|");

        this.storedValues = (<string>this.initialVal).split("|");
        this.drawGallery();
    }

    updateItem(item: any): any {
        let addArr: string[] = [];
        let removeArr: string[] = [];

        let initialArr = (<string>this.initialVal).split("|");

        // if it was there before and now isn't, remove it
        initialArr.forEach(x => {
            if (!this.storedValues.includes(x)) {
                removeArr.push(x);
            }
        });

        // if it wasn't there before and is not, add it
        this.storedValues.forEach(x => {
            if (!initialArr.includes(x)) {
                addArr.push(x);
            }
        })

        let updatedItem = _.cloneDeep(item);

        if (addArr.length > 0 || removeArr.length > 0) {
            let target = <string>_.get(updatedItem, this.propertyName);
            let targetArr = target.split("|");

            // remove items
            targetArr = targetArr.filter(val => !removeArr.includes(val));
            // add items
            targetArr.push(...addArr);
            // remove duplicates (if any)
            let uniqArr = _.uniq(targetArr);
            // convert back
            let newVal = uniqArr.join("|");

            _.set(updatedItem, this.propertyName, newVal);

        }
        return updatedItem;
    }

    private drawGallery(triggerChange: boolean = false) {
        this.addedItemGallery.empty();
        let content = "";
        if (this.storedValues.length == 0) {
            content = `<div class="added-content-placeholder">${this.options.noItemDisplay}</div>`;
            this.addedItemGallery.append(content);
        }
        else if (this.options.isPickList) {
            for (let i = 0; i < this.storedValues.length; i++) {
                let itemId = this.storedValues[i];
                let foundItem = this.options.options.find(item => item.Id.toString() == itemId);
                if (foundItem) {

                    let card = `
                        <div class="multi-add-card">
                            <div class="multi-add-card-header">
                                <div class="col">
                                    <div class="multi-add-card-title">${foundItem.Value}</div>
                                </div>
                                <div class="col-auto">
                                    <button class="butn small multi-add-delete-btn" data-item-index="${i}"><span><i class="fa-solid fa-trash-can"></i></span></button>
                                </div>
                            </div>
                        </div>
                    `

                    content += card;
                }
            }
            this.addedItemGallery.append(content);
            let multiAddField = this;
            this.addedItemGallery.find(".multi-add-delete-btn").on("click", function () {
                let targetIndex = $(this).data("itemIndex");
                let index: number = parseInt(targetIndex);
                let foundItem = multiAddField.storedValues[index];
                if (foundItem) {
                    multiAddField.storedValues.splice(index, 1);
                    multiAddField.drawGallery(true);
                }
            })
        }
        else {
            for (let i = 0; i < this.storedValues.length; i++) {
                let itemVal = this.storedValues[i];
                if (itemVal) {

                    let card = `
                        <div class="multi-add-card">
                            <div class="multi-add-card-header">
                                <div class="col">
                                    <div class="multi-add-card-title">${itemVal}</div>
                                </div>
                                <div class="col-auto">
                                    <button class="butn small multi-add-delete-btn" data-item-index="${i}"><span><i class="fa-solid fa-trash-can"></i></span></button>
                                </div>
                            </div>
                        </div>
                    `

                    content += card;
                }
            }
            this.addedItemGallery.append(content);
            let multiAddField = this;
            this.addedItemGallery.find(".multi-add-delete-btn").on("click", function () {
                let targetIndex = $(this).data("itemIndex");
                let index: number = parseInt(targetIndex);
                let foundItem = multiAddField.storedValues[index];
                if (foundItem) {
                    multiAddField.storedValues.splice(index, 1);
                    multiAddField.drawGallery(true);
                }
            });
        }

        this.refreshDropdown();
        if (triggerChange) {
            $(`#${this.fieldId}`).trigger("form-field-change")
        }
    }

    private generateDropdown() {
        this.addItemInput.find("option").remove();
        this.addItemInput.selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        // Add default option with no value to show no input (no favoritism)
        this.addItemInput.append(`<option hidden disabled selected value>-- Select --</option>`);

        if (this.options.sortOptions && this.options.options != undefined) {
            this.options.options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        }

        if (this.options.options != undefined) {
            this.options.options.forEach(option => {
                this.addItemInput.append(new Option(option.Value, option.Id.toString(), false, false));
            })
        }

        this.addItemInput.selectpicker("refresh");
    }

    // Remove selected items from dropdown
    private refreshDropdown() {
        if (this.options.options != undefined) {
            let options = this.options.options.filter(option => !this.storedValues.some(item => item == option.Id.toString()));

            if (this.options.sortOptions) {
                options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
            }

            this.addItemInput.find("option").remove();
            // Add default option with no value to show no input (no favoritism)
            this.addItemInput.append(`<option hidden disabled selected value>-- Select --</option>`);

            options.forEach(option => {
                this.addItemInput.append(new Option(option.Value, option.Id.toString(), false, false));
            });

            this.addItemInput.selectpicker("refresh");
        }
    }

    private initializeAddBtn() {
        this.addItemBtn.off().on('click', () => {
            let input = this.getInput();
            if (this.validateInput()) {
                this.storedValues.push(input);
                this.drawGallery(true);
                this.addItemInput.val('');

                if (this.options.isPickList) {
                    this.refreshDropdown();
                }
                this.setErrorText();
            }
            else {
                this.setErrorText("Please add at least 1 item");
            }
        })
    }

    private validateInput(): boolean {
        let input = this.getInput();
        if (input) {
            return true;
        }
        return false;
    }

    private setErrorText(errorText: string = null) {
        if (errorText == null) {
            this.errorTextBlock.text('');
            this.errorTextBlock.addClass('d-none');
            this.resetValidDisplay();
        }
        else {
            this.errorTextBlock.text(errorText);
            this.errorTextBlock.removeClass('d-none');
            this.displayValid(false);
        }
    }

    private getInput(): string {
        let input = <string>this.addItemInput.val();
        return input;
    }

    setOptions(pickLists: JsonItem[]) {
        if (this.options.isPickList) {
            let foundList = pickLists.find(list => list.Id == this.options.optionsId)?.Json;
            if (foundList) {
                this.options.options = foundList;
            }
        }
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.storedValues.join("|");
        }

        return val;
    }

    setValue(formData: any) {
        this.storedValues = [];
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            if (formVal) {
                this.storedValues = (<string>formVal).split("|");
            }
        }
        this.drawGallery();
    }

    checkValid(): boolean {
        if (this.isRequired) {
            if (this.storedValues.length == 0) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.storedValues.join("|");
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            if (this.options.isPickList) {
                this.addItemInput.siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
            }
            else {
                this.addItemInput.addClass("is-valid").removeClass("is-invalid");
            }
        }
        else {
            if (this.options.isPickList) {
                this.addItemInput.siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            }
            else {
                this.addItemInput.removeClass("is-valid").addClass("is-invalid");
            }
        }
    }

    resetValidDisplay() {
        if (this.options.isPickList) {
            this.addItemInput.siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        }
        else {
            this.addItemInput.removeClass("is-valid").removeClass("is-invalid");
        }
    }

    private getAddedDisplay(newItem: any, prevItem: any): string {
        // Updated List
        let x1Val = <string>_.get(newItem, this.propertyName);
        if (!x1Val) x1Val = "";
        let x1Arr = <string[]>_.get(newItem, this.propertyName);
        // Current List
        let x2Val = <string>_.get(prevItem, this.propertyName);
        if (!x2Val) x2Val = "";
        let x2Arr = <string[]>_.get(prevItem, this.propertyName);

        let addedArr: string[] = [];
        x1Arr.forEach(name => {
            if (!x2Arr.includes(name)) {
                addedArr.push(name);
            }
        });

        if (addedArr.length == 0) {
            return "";
        }

        if (this.options.isPickList && this.options.options) {
            let displayOptions: string[] = [];
            addedArr.forEach(name => {
                let foundItem = this.options.options.find(x => x.Value == name);
                if (foundItem) {
                    displayOptions.push(foundItem.Value);
                }
            })
                ;
            let listContent: string = "";
            displayOptions.sort();
            displayOptions.forEach(option => {
                listContent += `<li>${option}</li>`
            });
            return `<ul class="pl-2 mb-0">${listContent}</ul>`;
        }
        else {
            let listContent: string = "";
            addedArr.forEach(option => {
                listContent += `<li>${option}</li>`
            });
            return `<ul class="pl-2 mb-0">${listContent}</ul>`;
        }
    }

    private getRemovedDisplay(newItem: any, prevItem: any): string {
        // Updated List
        let x1Val = <string>_.get(newItem, this.propertyName);
        if (!x1Val) x1Val = "";
        let x1Arr = <string[]>_.get(newItem, this.propertyName);
        // Current List
        let x2Val = <string>_.get(prevItem, this.propertyName);
        if (!x2Val) x2Val = "";
        let x2Arr = <string[]>_.get(prevItem, this.propertyName);

        let rmArr: string[] = [];
        x2Arr.forEach(name => {
            if (!x1Arr.includes(name)) {
                rmArr.push(name);
            }
        });

        if (rmArr.length == 0) {
            return "";
        }

        if (this.options.isPickList && this.options.options) {
            let displayOptions: string[] = [];
            rmArr.forEach(name => {
                let foundItem = this.options.options.find(x => x.Value == name);
                if (foundItem) {
                    displayOptions.push(foundItem.Value);
                }
            })
                ;
            let listContent: string = "";
            displayOptions.sort();
            displayOptions.forEach(option => {
                listContent += `<li>${option}</li>`
            });
            return `<ul class="pl-2 mb-0">${listContent}</ul>`;
        }
        else {
            let listContent: string = "";
            rmArr.forEach(option => {
                listContent += `<li>${option}</li>`
            });
            return `<ul class="pl-2 mb-0">${listContent}</ul>`;
        }
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = <string>_.get(item1, this.propertyName);
        let x2 = <string>_.get(item2, this.propertyName);

        if (!x1 && !x2) {
            return true;
        }
        else if (!x1 || !x2) {
            return false;
        }

        let x1Arr = x1.split("|");
        let x2Arr = x2.split("|");

        if (x1Arr.length != x2Arr.length) {
            return false;
        }
        else {
            let arrSame = true;
            for (let i = 0; i < x1Arr.length; i++) {
                let x1 = x1Arr[i];
                if (!x2Arr.includes(x1)) {
                    arrSame = false;
                    return arrSame;
                }
            }
            return arrSame;
        }
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";

        let addedDisplay = this.getAddedDisplay(newItem, prevItem);
        if (addedDisplay) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${addedDisplay}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        let removeDisplay = this.getRemovedDisplay(newItem, prevItem);
        if (removeDisplay) {
            let prevDisplay = `
                    <div class="delete-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-trash-can delete-change-icon"></i>
                        </div>
                        <div class="col">
                            ${removeDisplay}
                        </div>
                    </div>
                `;
            changeContent += prevDisplay;
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}

